import React from "react";
import { getCommentaryPosition, getSportBallImage } from "../../../../../../pages/SportPage/sportPageData";
import { useSelector } from "react-redux";
import parse from 'html-react-parser';
import { COMMENTARY_POSITION, COURT_SEASON_CODES } from "../../../../../../lib/utils/sportCourtConfigs";

const PreviewCommnetary = ({ commentaryText, homeTeamScore, awayTeamScore, isFullScreen, hideScores, zone }) => {
  const { currentSeason } = useSelector((state) => state.seasons);
  const _zone = zone();
  const isFootball = currentSeason?.seasonCode === COURT_SEASON_CODES.FOOTBALL;
  const positioning = isFootball ? COMMENTARY_POSITION.PRIMARY : (_zone ? getCommentaryPosition(_zone, currentSeason?.seasonCode) : COMMENTARY_POSITION.PRIMARY);

  return (
    <div
      className={`
              absolute transform transition-all duration-700 ease-out bg-[#7396D0] px-2 py-1 pl-4 max-w-[calc(100%-40px)] animate-fadeIn running z-[2]
              screen-500:pl-5 screen-500:max-w-[450px]
              sm:max-w-[500px]
              ${(positioning === COMMENTARY_POSITION.TERTIARY || (positioning === COMMENTARY_POSITION.SECONDARY && !isFullScreen)) ? "mr-4 right-0 slide-in-from-right-5" : "ml-4 left-0 slide-in-from-left-5"}
              ${isFullScreen 
                ? (isFootball ? "top-16 left-2" : "bottom-10 left-2")
                : (positioning === COMMENTARY_POSITION.PRIMARY 
                  ? "top-16 left-3 screen-500:top-[26px]" 
                  : (positioning === COMMENTARY_POSITION.TERTIARY 
                    ? "top-16 right-3 screen-500:top-[26px]" 
                    : "bottom-2 right-0 screen-500:right-2 screen-500:bottom-3"))
              }
          `}
    >
      <figure className="absolute -left-5 -bottom-1">
        <img
          src={getSportBallImage(currentSeason?.seasonCode)}
          alt=""
          className="max-w-[30px] screen-500:max-w-[40px] h-auto"
        />
      </figure>
      <pre className="text-[12px] whitespace-normal screen-500:text-[13px] lg:text-[14px]">
        {commentaryText ? parse(commentaryText) : ""}
      </pre>

      {(isFullScreen || !hideScores) && (
        <div className="absolute right-0 -top-[1lh] text-[10px] screen-500:text-[12px]">
          Game Score:{" "}
          {`${homeTeamScore} - ${awayTeamScore}`}
        </div>
      )}
    </div>
  );
};

export default PreviewCommnetary;
